import request from '@/utils/request'
import { getUUID, isMobileDevice } from '@/utils/util'

export function getPicDetailsMostReadMsg() {
  return request({
    url: '/display/en/c/pc/home',
    method: 'get',
    headers: {
      plat: isMobileDevice() ? 'phone' : 'web',
      system: 'PC',
      versionCode: '120',
      imei: getUUID('PeoplesDaily')
    },
    prefix: import.meta.env.VITE_BASE_BFF_URL as string
  })
}

export function getChannel() {
  return request({
    url: '/display/en/c/pc/channel',
    method: 'get',
    prefix: import.meta.env.VITE_BASE_BFF_URL as string,
    headers: {
      plat: isMobileDevice() ? 'phone' : 'web',
      system: 'PC',
      versionCode: '120'
    }
  })
}

export function getRecommond(data) {
  return request({
    url: '/recommend/en/c/detail',
    method: 'post',
    data: data,
    headers: {
      plat: isMobileDevice() ? 'phone' : 'web',
      system: 'PC',
      versionCode: '120'
    },
    prefix: import.meta.env.VITE_BASE_BFF_URL as string
  })
}

export function getDetailsSuggest(config) {
  return request({
    ...config,
    headers: {
      plat: isMobileDevice() ? 'phone' : 'web',
      system: 'PC',
      versionCode: '120'
    },
    prefix: import.meta.env.VITE_BASE_BFF_URL as string
  })
}

export function getSuggestList(params) {
  return request({
    url: '/recommend/en/c/list',
    method: 'post',
    data: params,
    headers: {
      plat: isMobileDevice() ? 'phone' : 'web',
      system: 'PC',
      versionCode: '120'
    },
    prefix: import.meta.env.VITE_BASE_BFF_URL as string
  })
}

//用户订阅邮件接口
export function subscribeEmail(params) {
  return request({
    url: '/en/c/subscribe/sure',
    method: 'post',
    data: params,
    headers: {
      plat: isMobileDevice() ? 'phone' : 'web',
      system: 'PC',
      versionCode: '120'
    },
    prefix: import.meta.env.VITE_BASE_INTERACT_URL as string
  })
}

export function getDetails(params) {
  return request({
    url: '/content/en/c/content/detail',
    method: 'get',
    params: params,
    prefix: import.meta.env.VITE_BASE_BFF_URL as string,
    isMock: false
  })
}

export function getSerialsList(params = {}) {
  return request({
    url: '/content/en/c/content/serialsContentList',
    method: 'get',
    params,
    prefix: import.meta.env.VITE_BASE_BFF_URL as string,
  })
}

export function getImkey() {
  return request({
    url: '/en/a/live/getAppKey',
    method: 'get',
    prefix: import.meta.env.VITE_BASE_LIVE_URL as string,
  })
}

export function getImtoken(params) {
  return request({
    url: '/en/a/live/getToken',
    method: 'get',
    params,
    prefix: import.meta.env.VITE_BASE_LIVE_URL as string,
  })
}

export function getOldMessage(data) {
  return request({
    url: '/en/a/live/message/list',
    method: 'post',
    data,
    prefix: import.meta.env.VITE_BASE_LIVE_URL as string,
  })
}

